<template>
  <div>
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <div class="slider_img">
          <img :src="item.img"/>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="solve head-label">
      <div style="text-align: center; margin-top: 4%" class="font_size_24">
        阡客优势
      </div>
    </div>
    <!-- 盒子 -->
    <div class="border_parent">
      <el-row :gutter="10">
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[1].img" class="img_border"/>
            </div>
            <div class="border_title">{{ images[1].title }}</div>
            <div class="border_content_one">{{ images[1].content[0] }}</div>
            <div class="border_content_two">{{ images[1].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[2].img" class="img_border"/>
            </div>
            <div class="border_title">{{ images[2].title }}</div>
            <div class="border_content_one">{{ images[2].content[0] }}</div>
            <div class="border_content_two">{{ images[2].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[3].img" class="img_border"/>
            </div>
            <div class="border_title">{{ images[3].title }}</div>
            <div class="border_content_one">{{ images[3].content[0] }}</div>
            <div class="border_content_two">{{ images[3].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border" style="margin-right: 0">
            <div class="border_img_parent">
              <img :src="images[4].img" class="img_border"/>
            </div>
            <div class="border_title">{{ images[4].title }}</div>
            <div class="border_content_one">{{ images[4].content[0] }}</div>
            <div class="border_content_two">{{ images[4].content[1] }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 手机端商品展示 -->
    <div id="软件功能介绍" class="head-label">
      <div style="text-align: center;" class="font_size_24">
        阡客功能介绍
      </div>
    </div>
    <!--盒子-->
    <div class="border_parent">
      <el-row :gutter="10">
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="Ability[1].img" class="img_border"/>
            </div>
            <div class="border_title">{{ Ability[1].title }}</div>
            <div class="border_content_one">{{ Ability[1].content[0] }}</div>
            <div class="border_content_two">{{ Ability[1].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="Ability[2].img" class="img_border"/>
            </div>
            <div class="border_title">{{ Ability[2].title }}</div>
            <div class="border_content_one">{{ Ability[2].content[0] }}</div>
            <div class="border_content_two">{{ Ability[2].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="Ability[3].img" class="img_border"/>
            </div>
            <div class="border_title">{{ Ability[3].title }}</div>
            <div class="border_content_one">{{ Ability[3].content[0] }}</div>
            <div class="border_content_two">{{ Ability[3].content[1] }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border" style="margin-right: 0">
            <div class="border_img_parent">
              <img :src="Ability[4].img" class="img_border"/>
            </div>
            <div class="border_title">{{ Ability[4].title }}</div>
            <div class="border_content_one">{{ Ability[4].content[0] }}</div>
            <div class="border_content_two">{{ Ability[4].content[1] }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 后台管理 -->
    <!-- 产品特点-->
    <div id="APP软件特点" class="product_spec_title head-label">
      <div style="text-align: center;" class="font_size_24">
        阡客服务
      </div>
    </div>
    <div class="product_spec_parent">
      <div class="border_one border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[0].img" style="width: 50px;height: 50px"/>
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[0].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[0].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[0].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img"/>
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[1].img" style="width: 50px;height: 50px"/>
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[1].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[1].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[1].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img"/>
      </div>
      <div class="border_spec">
        <div class="border_spec_inner_one">
          <img :src="spec.product[2].img" style="width: 50px;height: 50px"/>
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[2].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[2].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[2].contents[1] }}
          </div>
        </div>
      </div>
      <div>
        <img :src="computeArrowImg" class="border_spec_img"/>
      </div>
      <div class="border_spec" style="margin-right: 0">
        <div class="border_spec_inner_one">
          <img :src="spec.product[3].img" style="width: 50px;height: 50px"/>
          <div style="margin-left:5px; font-weight: bold;" class="font_size_24">
            {{ spec.product[3].title }}
          </div>
        </div>
        <div style="display: flex;flex-direction: column;">
          <div class="border_spec_content_one">
            {{ spec.product[3].contents[0] }}
          </div>
          <div class="border_spec_inner_last">
            {{ spec.product[3].contents[1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data() {
    return {
      sliders: [],
      images: [
        {
          img: require('../../static/other/用户管理.png'),
          title: "用户管理",
          content: ["用户消费分析", "用户标签设定"]
        },
        {
          img: require('../../static/other/社交-合作.png'),
          title: "社交体系",
          content: ["是以居民为核心", "结合管理组织形成高效"]
        },
        {
          img: require('../../static/other/社区服务站.png'),
          title: "社区服务体系",
          content: ["建立社区生活服务生态", "提供方方面面的社区服务"]
        }, {
          img: require('../../static/other/24gf-city.png'),
          title: "城市体系",
          content: ["城市生活服务体系", "提供社会的资源互换"]
        },
        {
          img: require('../../static/other/软件管理.png'),
          title: "软件管理",
          content: ["APP多样功能", "生活方式多样化管理"]
        }
      ],
      Ability: [
        {
          img: require('../../static/other/用户管理.png'),
          title: "用户管理",
          content: ["用户消费分析", "用户标签设定"]
        },
        {
          img: require('../../static/other/朋友圈.png'),
          title: "阡客圈",
          content: ["类似微信朋友圈"]
        },
        {
          img: require('../../static/other/商务.png'),
          title: "商务",
          content: ["通过展示自己的资源进行互动"]
        }, {
          img: require('../../static/other/心愿单.png'),
          title: "故事墙",
          content: ["好友之间的故事记录"]
        },
        {
          img: require('../../static/other/互动交流.png'),
          title: "实时通讯",
          content: ["类似微信的聊天和群聊"]
        }
      ],
      spec: {
        img: require('../../static/other/arrow.png'),
        product: [
          {
            img: require('../../static/other/个人.png'),
            title: "个人",
            contents: ["建立以自身需求", "让社交为商务服务带来价值"]
          },
          {
            img: require('../../static/other/家庭.png'),
            title: "家庭",
            contents: ["建立家庭线上空间", "管理家庭历史，文化，财物，沟通"]
          },
          {
            img: require('../../static/other/社区.png'),
            title: "社区",
            contents: ["分类信息及服务社区生活", "以线上信息交流，服务线下生活"]
          },
          {
            img: require('../../static/other/城市.png'),
            title: "城市",
            contents: ["通过触发事件", "进行活动交流"]
          }
        ]
      },
      carousel_height: '550px',
    }
  },
  methods: {},
  mounted() {
    this.sliders = [
      {
        img: require("../assets/imq1.png"),
      },
      {
        img: require("../assets/imq2.png")
      },
      {
        img: require('../assets/imq4.png')
      },
    ]
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return '600px';
      } else {
        return '250px';
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require('../../static/other/arrow.png');
      } else {
        return require('../../static/other/arrow_down.png');
      }
    }

  },
}
</script>

<style scoped>
    .border_parent {
      width: 80%;
      margin: 4% auto;
    }

    .slider_img {
      text-align: center;
      height: 540px;
    }

    .slider_img > img {
      height: 540px;
      /*width: 100%;*/
      margin-top: 7%;
    }

    .solve {
      margin-top: 30px;
      margin-bottom: 10px
    }

    .border {
      border-radius: 6px;
      border: 1px solid #EBEEF5;
      height: auto;
      margin: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
      margin-left: 0;
    }

    .border_img_parent {
      margin-top: 20px;
      display: flex;
      justify-content: center;
    }

    .product_mobile_img_right > img {
      border-radius: 20px;
      width: 80%;
    }

    .product_font_style_list > div {
      margin-top: 20px;
    }

    .product_pc_list > div {
      margin-top: 10%;
    }

    .product_pc_list > div >div {
      text-align: center;
      margin: 5px auto;
      font-family: 华文宋体;
      width: 70%;
    }

    .product_spec_title {
      margin-top: 30px;
      margin-bottom: 10px
    }

    .product_spec_parent {
      display: flex;
      width: 90%;
      margin: 4% auto;
      align-items: center;
      height: auto
    }

    .border_spec {
      white-space: nowrap;
      border-radius: 6px;
      border: 1px solid #EBEEF5;
      float: left;
      width: 56%;
      height: auto;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .border_title {
      font-family: "PingFang SC";
      margin-top: 10px;
      font-size: 1.125em;
      font-weight: bold;
      text-align: center;
    }

    .border_content_one {
      margin-top: 20px;
      font-size: 1.125em;
      text-align: center;
    }

    .border_content_two {
      margin-top: 5px;
      font-size: 1.125em;
      margin-bottom: 25px;
      text-align: center;
    }

    .img_border {
      margin-top: 15px;
      width: 80px;
      height: 80px
    }

    .border_spec_inner_one {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 35px;
      height: 70px;
    }

    .border_spec_content_one {
      margin-top: 15px;
      font-size: 1.125em;
      float: left;
      text-align: center;
    }

    .border_spec_inner_last {
      margin-top: 15px;
      font-size: 1.125em;
      float: left;
      margin-bottom: 25px;
      text-align: center;
    }

    .product_mobile_content_list > div {
      padding-top: 43px;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
      .slider_img {
        height: 250px;
        width: 100%;
      }


      .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
      }

      .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 100%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
        /*background: aquamarine;*/
      }

      .border_img_parent {
        margin-top: 0;

      }

      .product_mobile_title {
        font-weight: bold;
      }

      .head-label {
        display: flex;
        margin-top: 10px;
      }

      .product_spec_parent {
        display: flex;
        width: 90%;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        height: auto;
        flex-direction: column;
      }

      .border_spec {
        float: left;
        height: auto;
        margin: 8px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }


      .border_title {
        font-family: "PingFang SC";
        margin-top: 5px;
        font-size: 1.125em;
        font-weight: bold;
      }

      .border_content_one {
        margin-top: 5px;
        font-size: 1.125em;
      }

      .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
      }

      .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px
      }

      .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        height: 70px;
      }

      .border_spec_content_one {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
      }

      .border_spec_inner_last {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 8px;
      }
    }

    .border_spec_img {
      width: 75px;
      height: 55px;
      align-self: center
    }

    .font_size_24 {
      font-size: 1.5em;
    }
</style>